module.exports = __webpack_public_path__ + "static/media/btnBg.edafa67e.png";